import { resolveSupportModeHeaders } from 'src/modules/shared/utils/http/support-mode-headers.util';
import type { OutboundMessageSubmission } from '../../types/whatsapp/outbound-message.types';

/** Key reserved for the active Communications composer's local mutation lifecycle. */
export const OUTBOUND_MESSAGE_MUTATION_KEY = [
  'communications/outbound-message',
];

/**
 * Recognizes internally constructed submissions in the account's mutation cache.
 * This is an internal discriminator, not a validator for external message payloads.
 * @param value - Variables from a mutation under the owned key.
 * @returns Whether the variables belong to this composer.
 */
export const isOutboundMessageSubmission = (
  value: unknown
): value is OutboundMessageSubmission =>
  typeof value === 'object' &&
  value !== null &&
  'kind' in value &&
  value.kind === 'communications.whatsapp.send' &&
  'params' in value &&
  'optimisticMessage' in value;

/**
 * Captures the transport ordering scope independently of selected UI addresses.
 * @param submission - Immutable request and conversation context.
 * @returns The key shared by submissions to this destination.
 */
export const getOutboundMessageDestination = ({
  params,
}: OutboundMessageSubmission): string =>
  JSON.stringify([
    params.optimisticData?.funnelConversationId,
    params.fromPhoneNumber,
    params.toPhoneNumber,
  ]);

/**
 * Captures the tenant override used by the generated HTTP client.
 * @returns Stable support scope, without credentials or message content.
 */
export const getOutboundSupportScope = (): string =>
  JSON.stringify(resolveSupportModeHeaders());
